import React, { useEffect, useRef, useState } from "react"
import Heading from "../../common/heading/Heading"
import "./Hero.css"

const statsConfig = [
  { label: "Learners", target: 5000, suffix: "+" },
  { label: "Courses", target: 120, suffix: "+" },
  { label: "Industry Partners", target: 50, suffix: "+" },
  { label: "Awards", target: 10, suffix: "+" }
]

const featureItems = [
  { icon: "💻", text: "Hands-on Labs" },
  { icon: "🎓", text: "Expert Mentors" },
  { icon: "🧪", text: "Industry Projects" },
  { icon: "🚀", text: "Career Support" }
]

const Hero = () => {
  const [stats, setStats] = useState(statsConfig.map(s => ({ ...s, value: 0 })))
  const [hasAnimated, setHasAnimated] = useState(false)
  const sectionRef = useRef(null)
  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

  useEffect(() => {
    const el = sectionRef.current
    if (!el) return
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasAnimated) {
        setHasAnimated(true)
        const duration = 1800
        const start = performance.now()
        const animate = () => {
          const now = performance.now()
          const progress = Math.min(1, (now - start) / duration)
          setStats(prev => prev.map(s => ({
            ...s,
            value: Math.round(s.target * easeOutCubic(progress))
          })))
          if (progress < 1) requestAnimationFrame(animate)
        }
        requestAnimationFrame(animate)
      }
    }, { threshold: 0.35 })
    observer.observe(el)
    return () => observer.disconnect()
  }, [hasAnimated])

  return (
    <>
      <section className='hero' ref={sectionRef} aria-labelledby="hero-heading" role="banner">
        <div className='hero-overlay'></div>
        <div className='container'>
          <div className='hero-content'>
           
            <Heading  title={<span id="hero-heading" className='hero-title-gradient'>“The Sky is Your Limit”</span>} />
            <p ></p>

            <div className='hero-stats' aria-label='Key institute statistics'>
              {stats.map(s => (
                <div className='stat-item' key={s.label}>
                  <span className='stat-number' aria-live='polite'>{s.value}{s.value === s.target ? s.suffix : ''}</span>
                  <span className='stat-label'>{s.label}</span>
                </div>
              ))}
            </div>
           
          </div>
        </div>
      </section>
      <div className='margin'></div>
    </>
  )
}

export default Hero
